"use strict";
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postTransferDirectory = exports.getOrganizationsDirectory = exports.getOrganizationsDirectories = exports.getOrganizationsDirectoryDomains = void 0;

const utils_1 = require("../utils");

const getOrganizationsDirectoryDomains = (jilFetch, options) => {
  const path = `organizations/${options.orgId}/directories/${options.directoryId}/domains`;
  const params = utils_1.omitIfNil({
    page: options.pageNumber,
    page_size: options.pageSize,
    search_query: options.filterQuery,
    sort: options.sortExpression,
    sort_order: options.sortOrder
  });
  return jilFetch(path, params, {
    method: 'GET'
  });
};

exports.getOrganizationsDirectoryDomains = getOrganizationsDirectoryDomains;

const getOrganizationsDirectories = (jilFetch, options) => {
  const path = `organizations/${options.orgId}/directories`;
  const params = utils_1.omitIfNil({
    page: options.pageNumber,
    page_size: options.pageSize,
    search_query: options.filterQuery,
    sort: options.sortExpression,
    sort_order: options.sortOrder
  });
  return jilFetch(path, params, {
    method: 'GET'
  });
};

exports.getOrganizationsDirectories = getOrganizationsDirectories;

const getOrganizationsDirectory = (jilFetch, options) => {
  const path = `organizations/${options.orgId}/directories/${options.directoryId}`;
  return jilFetch(path, {}, {
    method: 'GET'
  });
};

exports.getOrganizationsDirectory = getOrganizationsDirectory;

const postTransferDirectory = (jilFetch, options) => {
  const path = `organizations/${options.orgId}/directories:move`;
  return jilFetch(path, {}, {
    body: JSON.stringify(options.requestBody),
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST'
  });
};

exports.postTransferDirectory = postTransferDirectory;